import { Box, Stack, Tooltip, Typography } from "@mui/joy";
import { EXPERTISE_LEVELS } from "../profileFields";

type ExpertiseMeterProps = {
  label: string;
  value: string | number | undefined | null;
};

// 0-3 scale, an unset value counts as the lowest level (as before)
const getLevel = (value: ExpertiseMeterProps["value"]) => {
  const level = typeof value === "string" ? parseInt(value) : value ?? 0;
  return Number.isFinite(level) ? Math.min(Math.max(level as number, 0), EXPERTISE_LEVELS.length - 1) : 0;
};

function ExpertiseMeter({ label, value }: ExpertiseMeterProps) {
  const level = getLevel(value);

  return (
    <Tooltip title={EXPERTISE_LEVELS[level]} placement="top" size="sm">
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={2} sx={{ py: 0.5 }}>
        <Typography level="body-sm" textColor="text.primary" noWrap>
          {label}
        </Typography>
        <Stack direction="row" gap={0.5} aria-label={`${label}: ${EXPERTISE_LEVELS[level]}`} role="img">
          {EXPERTISE_LEVELS.map((_, index) => (
            <Box
              key={index}
              sx={{
                width: 22,
                height: 6,
                borderRadius: "sm",
                backgroundColor: index <= level ? "primary.500" : "neutral.200",
              }}
            />
          ))}
        </Stack>
      </Stack>
    </Tooltip>
  );
}

export default ExpertiseMeter;
